module.exports = __webpack_public_path__ + "static/media/logo-box.8294d55a.svg";